
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 7A6 6 0 111 7a6 6 0 0112 0zm1 0A7 7 0 110 7a7 7 0 0114 0zM7.5 3.5a.5.5 0 00-1 0V7a.5.5 0 00.5.5h3.5a.5.5 0 000-1h-3v-3z","fill":"currentColor"}})])
          )
        }
      }
    